import React, { useState } from "react";
import { ImageOff } from "lucide-react";

/**
 * Central artwork component.
 * - Uses official cover_image URL (from centralized music library).
 * - Falls back to a clearly-labeled 'Artwork Missing' state — never a random placeholder image.
 */
const Artwork = ({ src, alt = "", className = "", rounded = "rounded-2xl", ...rest }) => {
  const [err, setErr] = useState(false);
  const hasSrc = !!src;

  if (!hasSrc || err) {
    return (
      <div
        className={`relative flex flex-col items-center justify-center bg-[#0f0f0f] border border-white/10 ${rounded} ${className}`}
        data-testid="artwork-missing"
        role="img"
        aria-label={alt || "Artwork missing"}
        {...rest}
      >
        <div className="absolute inset-0 opacity-40 pointer-events-none"
             style={{ background: "radial-gradient(60% 60% at 50% 50%, rgba(255,153,51,0.12), transparent 70%)" }} />
        <ImageOff className="text-white/40" size={28} />
        <div className="mt-3 text-[10px] uppercase tracking-[0.35em] text-white/50">Artwork Missing</div>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setErr(true)}
      className={`${className} ${rounded}`}
      {...rest}
    />
  );
};

export default Artwork;
